"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderCancellationRo = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.OrderCancellationRo = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    csa_name: typebox_1.Type.String(),
    order_number: typebox_1.Type.String(),
    service_location: typebox_1.Type.String(),
});
//# sourceMappingURL=order-cancellation-ro.js.map